module.exports = __webpack_public_path__ + "img/21csm_Ersa-Selective-SMARTFLOW-006-900x600_ae6f26d723.b98133fa.jpg";